export default __webpack_public_path__ + "static/media/notification.c594ed77.png";